import{QueryClient as e}from"@tanstack/react-query";var t=new e({defaultOptions:{queries:{staleTime:12e4,gcTime:12e4,refetchOnWindowFocus:!1,refetchOnMount:!0,refetchOnReconnect:!0}}});export{t as queryClient};
